<div class="spinner-wrapper">
  <div class="donut"></div>
</div>